module.exports = __webpack_public_path__ + "static/utp-logo-ced98694866977290c99e415afa6c3c6.png";